import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navWrapper", "panel", "mask"]

  show(event) {
    event.preventDefault()
    this.navWrapperTarget.classList.add("show")
  }

  hide(event) {
    event.preventDefault()
    this.navWrapperTarget.classList.remove("show")
  }
}
